export const loginPageSelector = state => ({
  errorMessage: state.auth.errorMessage,
  authLoading: state.auth.loading,
  registerEmail: state.auth.registerEmail,
  authModal: state.auth.modal,
  modalState: state.auth.modalState,
});
